import React from 'react';
import {Observer} from 'mobx-react';
import {Dropdown} from './Dropdown';
import 'react-tippy/dist/tippy.css';
import { Tooltip } from 'react-tippy';

export class ItemDescriptor extends React.Component {
    render() {
        return (
          <div className="described-item">
            <a className="help-tooltip">{this.props.children}
                {(this.props.description || this.props.html) && <Tooltip 
                    className="tooltip-container"
                    title={this.props.description}
                    html={this.props.html}
                    animation="shift"
                    arrow="true"
                    theme="light"
                    trigger="click"
                    sticky={true}
                    stickyDuration={100}>
                    <i className="fa fa-question-circle" aria-hidden="true"></i>
                </Tooltip>}
            </a>
          </div>        
        )
    }
}


// WEBPACK FOOTER //
// ./src/visual/component/ItemDescriptor.js